// extracted by mini-css-extract-plugin
module.exports = {"ScrollContainer":"styles_ScrollContainer__3Ozrs"};